'use client'

import { lazy } from 'react'

// The server footer has its own Suspense boundary. Preserve its SSR content
// without adding its behavior to the header's initial script requests.
const FooterSignedInRow = lazy(() =>
  import('./footer-signed-in-row').then((module) => ({ default: module.FooterSignedInRow }))
)

export const FooterSignedInRowLazy = () => <FooterSignedInRow />
